/**
 * FAQ Data
 * Frequently asked questions
 */
const assetsUrl = `${window.template_root}/src/public/`;

export const faqs = [
  {
    id: "1",
    question: "What is a synbiotic supplement?",
    answer:
      "<p>A synbiotic supplement combines probiotics and prebiotics to improve gut health, digestion, and microbiome balance. It enhances nutrient absorption and immune support. Naori custom blend includes an enzyme complex as well, ensuring faster results.</p>",
  },
  {
    id: "2",
    question: "How's Naori different from other weight-loss pills?",
    answer:
      "<p>Naori is different from typical weight-loss pills because it works with your gut, not against your body. Instead of relying on stimulants or extreme dieting, it uses targeted probiotics and prebiotics to support your microbiome, helping improve digestion, reduce bloating and cravings, balance gut bacteria, and naturally support a healthier metabolism.</p>",
  },
  {
    id: "3",
    question: "How fast can I expect to see any noticeable results?",
    answer:
      "<p>Everyone's gut microbiome is as unique as a fingerprint, so results can vary from person to person. While it usually takes <strong>6-8 weeks</strong> for beneficial bacteria to fully establish in your gut, many people begin to notice positive changes within the <strong>first 30 days</strong>.</p><p>For optimal results, we recommend taking <strong>Naori probiotics for at least 3 months</strong>. Along the way, here's what you may start experiencing:</p><ul><li>More stable energy throughout the day</li><li>Smoother, more comfortable digestion</li><li>Less gut discomfort (such as bloating or gas)</li><li>Better appetite control and fewer cravings</li></ul>",
  },
  {
    id: "4",
    question: "What ingredients are used in Naori?",
    answer: `<img src="${assetsUrl}img/supplement-facts.webp" alt="Supplement facts" />`,
  },
  {
    id: "5",
    question: "Why are probiotics important?",
    answer:
      "<p>Probiotics play an important role in digestion and overall health. They support healthy digestion, help promote lasting fullness, and may reduce hunger and cravings. Probiotics also help lower inflammation, bind and remove toxins, and protect the gut lining.</p><p>In addition, maintaining a balanced gut microbiome has been linked to a lower risk of certain chronic conditions, including heart disease and type 2 diabetes.</p>",
  },
  {
    id: "6",
    question: "How long should I take Naori for?",
    answer:
      "<p>For best results, we recommend taking <strong>Naori for 3-6 months</strong>. But don't worry - the time flies by as you start feeling the benefits along the way!</p>",
  },
  {
    id: "7",
    question: "Can I take other supplements with Naori?",
    answer:
      "<p>Absolutely! You can take most vitamins and supplements alongside Naori. For best results, take it with meals and space out minerals like calcium or iron if needed.</p>",
  },
  {
    id: "8",
    question: "Can I take Naori if I have IBS?",
    answer:
      "<p>Yes, many people with IBS find synbiotics helpful for digestion and gut balance. Start with a small dose to see how your body responds, and adjust as needed.</p>",
  },
  {
    id: "„",
    question: "Can I take it with high blood pressure meds?",
    answer:
      "<p>Current <a href=\"https://www.ahajournals.org/doi/full/10.1161/hypertensionaha.114.03469\" target='_blank' rel='noopener noreferrer'>research</a> suggests that probiotics may help lower blood pressure slightly. There are no known interactions between probiotics and blood pressure medications, so they are generally considered safe to take together. However, we always recommend consulting your doctor to assess your individual situation before combining any supplements or medications with Naori.</p>",
  },
];

export default faqs;
